import { useEffect, useRef } from 'react'
import { TextcutRectangle } from '../types'
import { toast } from 'react-toastify'
import { deleteReferencesWithBindingIds } from '../slice/referenceSlice'
import { useAppDispatch } from '../dispatch'
import mittEmitter from '../utils/mitt'

const useDeleteReference = (
  dispatch: ReturnType<typeof useAppDispatch>,
  references: TextcutRectangle[]
) => {
  const dispatchRef = useRef(dispatch)

  useEffect(() => {
    const handler = ({
      rangeAddress,
      sheetId,
    }: {
      sheetId: string
      rangeAddress: string
    }) =>
      Excel.run(async (ctx) => {
        try {
          const sheet = ctx.workbook.worksheets.getItemOrNullObject(sheetId)
          sheet.load(['isNullObject'])
          await ctx.sync()
          if (sheet.isNullObject) return
          const range = sheet.getRange(rangeAddress)
          const filtered = references.filter((ref) => ref.sheetId === sheetId)
          const filteredMap = new Map<string, TextcutRectangle>()
          filtered.forEach((ref) => filteredMap.set(ref.bindingId, ref))
          const intersectedMap = new Map<string, Excel.Range>()
          filtered.forEach((ref) => {
            const r = range.getIntersectionOrNullObject(ref.rangeAddr)
            r.load(['isNullObject'])
            intersectedMap.set(ref.bindingId, r)
          })
          await ctx.sync()
          const bindingMap = new Map<string, Excel.Binding>()
          for (const [k, v] of intersectedMap) {
            if (v.isNullObject) continue
            const bindingItem = ctx.workbook.bindings.getItemOrNullObject(k)
            bindingItem.load(['isNullObject'])
            bindingMap.set(k, bindingItem)
          }
          await ctx.sync()
          const toBeDeleteIds = new Set<string>()
          for (const [k, v] of bindingMap) {
            if (v.isNullObject) continue
            v.delete()
            const item = filteredMap.get(k)
            if (!item) continue
            if (!item.bindingGroupId) toBeDeleteIds.add(item.bindingId)
            else {
              filtered
                .filter((elem) => elem.bindingGroupId === item.bindingGroupId)
                .forEach((elem) => {
                  toBeDeleteIds.add(elem.bindingId)
                })
            }
          }
          await dispatchRef.current(
            deleteReferencesWithBindingIds({
              bindingIds: [...toBeDeleteIds],
              deleteGroup: true,
            })
          )
          await ctx.sync()
          toast.success('🔗Link removed successfully.')
        } catch (err) {
          console.error(err)
          toast.error(`Failed to delete link, error: ${err}`)
        }
      })

    mittEmitter.on('ReferenceDeletion', handler)

    return () => {
      mittEmitter.off('ReferenceDeletion', handler)
    }
  }, [references])
}

export default useDeleteReference
